import { render, staticRenderFns } from "./OrderDialogForm.vue?vue&type=template&id=18bfd4e2"
import script from "./OrderDialogForm.vue?vue&type=script&lang=js"
export * from "./OrderDialogForm.vue?vue&type=script&lang=js"
import style0 from "./OrderDialogForm.vue?vue&type=style&index=0&id=18bfd4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports